import React  from 'react';
import { Modal } from 'react-bootstrap';
import {useLocation} from "react-router-dom";

export const videoLinks = {
    '/crypto': 'https://www.youtube.com/embed/4yNdJ0jCVz4',
    '/facebook': 'https://www.youtube.com/embed/btZiVyyiAow',
    '/link-list': 'https://www.youtube.com/embed/gZ-KMBjj75k',
    '/map': 'https://www.youtube.com/embed/61xotyvKkU8',
    '/multiurl': 'https://www.youtube.com/embed/ImW60gigLus',
    '/pcr': 'https://www.youtube.com/embed/L_jGhmuE9l4',
    '/telegram': 'https://www.youtube.com/embed/nuUoMes3Y4E',
    '/pptx': 'https://www.youtube.com/embed/djv9cnaNiH4'
};

const VideoModal = ({ showModal, handleClose }) => {
    const { pathname } = useLocation();
    const selectedVideoLink = videoLinks[pathname] || '';

    return (
        <Modal show={showModal} onHide={handleClose} size="lg" contentClassName="rounded-0 modal-centered" dialogClassName="modal-dialog-centered">
            <Modal.Body className="p-0 rounded-0">
                <iframe
                    width="100%"
                    height="500"
                    src={selectedVideoLink}
                    title="YouTube Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            </Modal.Body>

        </Modal>
    );
};

export default VideoModal;
